import { Country } from '@backmarket/http-api/src/standards/Country'

export type NationalIdCountries = Extract<
  Country,
  Country.ES | Country.IT | Country.PT
>

export const NationalIdCountries = {
  [Country.ES]: Country.ES,
  [Country.IT]: Country.IT,
  [Country.PT]: Country.PT,
}
